<template>
  <v-menu transition="none" offset-y bottom left :close-on-content-click="false">
    <template v-slot:activator="{ on: menu, attrs }">
       <v-tooltip :disabled="!title" bottom transition="none" color="black">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn :icon="['icon'].includes(mode)" :depressed="['text','both'].includes(mode)" v-bind="attrs" v-on="{ ...tooltip, ...menu }" :disabled="disabled">
            <v-icon :size="24" v-if="['icon','both'].includes(mode)" :left="mode == 'both'">{{ icon }}</v-icon>
            <template v-if="['text','both'].includes(mode)">{{ selected }}</template>
          </v-btn>
        </template>
        <span>{{ title }}</span>
       </v-tooltip>
    </template>
    <v-list dense subheader style="max-height: 528px; overflow-y: auto;">
      <v-subheader>{{ title }}</v-subheader>
      <v-list-item-group v-model="selected" :mandatory="mandatory" :multiple="multiple">
        <v-list-item v-for="(item, index) in options" :key="index" :value="item.value">
          <template v-slot:default="{ active }">
            <v-list-item-action class="mr-4">
              <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content class="text-no-wrap">{{ item.text }}</v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'AxMenu',
  props: {
    mandatory: { type: Boolean, default: true },
    multiple: { type: Boolean, default: false },
    icon: { type: String, required: true },
    title: { type: String, required: true },
    options: { type: Array, required: true },
    default: { required: true },
    mode: { type: String, default: 'icon' },
    model: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  watch: {
    'selected': function() {
      this.$emit('changed', this.selected, this.model)
    },
    'default': function(val) {
      this.selected = val
    }
  },
  created() {
    this.selected = this.default
  },
  data() {
    return {
      selected: null,
    }
  }
}
</script>